import React from "react";
import { Grid, Header, Image, Segment } from "semantic-ui-react";
import styles from './OverviewModuleDescription.module.css';

const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const FamilyModuleDescription: React.FC = () => {
  return (
    <Segment basic id={styles['medicalOverview']}>
      <p className={styles.overviewText}>
        At some point in their lives, most older adults will require help from
        others because of problems caused by chronic health conditions, mobility
        limitaions, and/or sensory changes. Such help is typically provided by
        family members which makes care for older adults an issue for all
        generations.
      </p>
      <p className={styles.overviewText}>
        Caregiving is a family affair. Careful planning and forethough can
        clarify values and help older adults share information and preferences
        about care before care is needed.
      </p>
      <p className={styles.overviewText}>
        This section of the AgeReady program will help you prepare proactively
        for the challenges that may arise with caregiving and to provide
        resources to assist families and caregivers as they navigate this new
        stage of life with the older adult.
      </p>
      <Segment raised className={styles.segmentObjectives}>   
        <Header className={styles.objectivesGroupHeader} >Objectives </Header>     
        <Grid stackable>
          <Grid.Row columns='equal' stretched className={styles.objectivesItemRow} >
            <Grid.Column stretched className={`${styles.objectivesItemColumn} ${styles.objItemColLeft}`} >
              <Segment raised className={styles.objectivesItemWhiteBG} >  
                <Header as='h2' icon className={styles.objectivesItemHeader} >
                  <Segment className={styles.objectivesItemIconAndLabel} >
                    <Image src={`${iconRoute}DiscussIcon.png`} className={styles.objectivesItemHeaderImgIcon} />
                    <p className={styles.objectivesItemHeaderTitle} >DISCUSS </p> 
                  </Segment>
                  <Header.Subheader className={styles.objectivesItemSubheader} > 
                    Learn which conversations are needed to ensure the older adult's needs
                    and wishes are met. 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched className={`${styles.objectivesItemColumn} ${styles.objItemColMiddle}`} >
              <Segment raised className={styles.objectivesItemWhiteBG} >  
                <Header as='h2' icon className={styles.objectivesItemHeader} >
                  <Segment className={styles.objectivesItemIconAndLabel} >
                    <Image src={`${iconRoute}FrameworkIcon.png`} className={styles.objectivesItemHeaderImgIcon} />
                    <p className={styles.objectivesItemHeaderTitle} >COLLABORATE </p>
                  </Segment>
                  <Header.Subheader className={styles.objectivesItemSubheader} > 
                    To provided a framework in which you and other caregivers can work
                    together to create a plan before any unexpected health events.
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched className={`${styles.objectivesItemColumn} ${styles.objItemColRight}`} >
              <Segment raised className={styles.objectivesItemWhiteBG} >  
                <Header as='h2' icon className={styles.objectivesItemHeader} >
                  <Segment className={styles.objectivesItemIconAndLabel} >
                    <Image src={`${iconRoute}ExploreIcon.png`} className={styles.objectivesItemHeaderImgIcon} />
                    <p className={styles.objectivesItemHeaderTitle} >EXPLORE </p>
                  </Segment>
                  <Header.Subheader className={styles.objectivesItemSubheader} > 
                    Explore different ideas that can help improve your loved one's overall quality of life.
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </Segment>
  );
};

export default FamilyModuleDescription;
